// =============================================================================
// actions/siteActions.js
//
// Thunk to load the list of sites with coordinates. Defensive catch:
// if `err` arrives undefined (e.g. a throw inside the thunk itself before
// axios runs), it won't blow up with "Cannot read 'response' of undefined".
// =============================================================================
import {
	SITES_FETCH_REQUEST, SITES_FETCH_SUCCESS, SITES_FETCH_FAILURE,
} from '../constants/kpiConstants';
import { apiFetchSites } from '../requests/kpiRequests';

function extractErrorMessage(err) {
	if (!err) return 'Unknown error';
	if (err.response && err.response.data) {
		if (err.response.data.error)   return err.response.data.error;
		if (err.response.data.message) return err.response.data.message;
		if (typeof err.response.data === 'string') return err.response.data;
	}
	if (err.message) return err.message;
	return 'Unknown error';
}

export function fetchSites() {
	return async function (dispatch) {
		dispatch({ type: SITES_FETCH_REQUEST });
		try {
			const res = await apiFetchSites();
			dispatch({ type: SITES_FETCH_SUCCESS, payload: (res && res.data) || [] });
		} catch (err) {
			dispatch({
				type: SITES_FETCH_FAILURE,
				payload: extractErrorMessage(err),
			});
		}
	};
}
